const SETTINGS = {
  locales: ['en', 'de'],
  baseUrl: '/',
  publicURL: '/assets',
};

export default SETTINGS;
